import { Provision } from "./provision";

export class ProvisionItem {

  Type: string;
  Family: string;
  FamilyDescription: string;
  Execution: string;
  ExecutionDescription: string;
  Recommended: boolean;
  SpisaInfoExists: boolean;
  IsECUControlling: boolean;

  constructor(type?: string, family?: string, familydescription?: string, execution?: string, executiondescription?: string, recommended?: boolean,spisaInfoExists?:boolean, isECUControlling?: boolean) {
    this.Type = type;
    this.Family = family;
    this.FamilyDescription = familydescription;
    this.Execution = execution;
    this.ExecutionDescription = executiondescription;
    this.Recommended = recommended;
    this.SpisaInfoExists = spisaInfoExists;
    this.IsECUControlling = isECUControlling;
  }

  static fromOAS(data:any){
    let provisionItem = new ProvisionItem();
    
    if (data != null){
      var descriptions = data['complement'].split(':');        
      provisionItem.Type = data["type"].substring(0,3).toUpperCase();
      provisionItem.Family = data["type"].substring(3);  
      provisionItem.FamilyDescription = descriptions[0];
      provisionItem.Execution = data["instance"]
      provisionItem.ExecutionDescription = descriptions[1];    
      provisionItem.SpisaInfoExists = false;
      provisionItem.IsECUControlling = false;
    }
    
    return provisionItem;
  }
}
